import { combineReducers } from 'redux';
import { firestoreReducer } from 'redux-firestore';
import { firebaseReducer } from 'react-redux-firebase';
import { reducer as formReducer } from 'redux-form';

import authReducer from './authReducer';
import proposalsReducer from './proposalsReducer';
import dataBaseReducer from './dataBaseReducer';
import kerrokantasiReducer from './kerrokantasiReducer';

export function makeRootReducer(asyncReducers) {
  return combineReducers({
    // Add sync reducers here
    auth: authReducer,
    proposals: proposalsReducer,
    dataBase: dataBaseReducer,
    firestore: firestoreReducer,
    firebase: firebaseReducer,
    form: formReducer,
    hearingData: kerrokantasiReducer,
    ...asyncReducers,
  });
}

export function injectReducer(store, { key, reducer }) {
  store.asyncReducers[key] = reducer; // eslint-disable-line no-param-reassign
  store.replaceReducer(makeRootReducer(store.asyncReducers));
}

export default makeRootReducer;
